import React from 'react';
import { Add } from '@mui/icons-material';
import CheckIcon from '@mui/icons-material/Check';
import { ButtonBase, Checkbox, type CheckboxProps } from '@mui/material';
import { twMerge } from 'tailwind-merge';

export type IntegrationsCheckboxCardProps = CheckboxProps;

export function IntegrationsCheckboxCard(props: IntegrationsCheckboxCardProps & { children: React.ReactNode }) {
  const { checked, children, className, disabled, ...rest } = props;

  return (
    <ButtonBase
      component="label"
      disabled={disabled}
      className={twMerge(
        'flex items-center justify-between w-full cursor-pointer group',
        'border border-solid rounded-md box-border p-4 min-h-32 h-fit hover:shadow-blue-3 transition-shadow',
        checked ? 'border-blue-800 bg-grey-100' : 'border-grey-300',
        className
      )}
    >
      <div className="flex flex-col items-start w-5/6 gap-4">{children}</div>
      <Checkbox
        {...rest}
        disabled={disabled}
        checked={checked}
        className="p-0 m-0"
        disableRipple={true}
        icon={
          <Add className="text-[40px] p-3 bg-grey-100 rounded-full text-blue-800 transition-colors group-hover:bg-blue-50" />
        }
        checkedIcon={
          <CheckIcon
            className="text-[40px] text-white p-3 rounded-full"
            style={{ backgroundImage: 'linear-gradient(to right, hsl(251 48% 48%), hsl(207, 93%, 52%))' }}
          />
        }
      />
    </ButtonBase>
  );
}
